import { CaptchaProviderDef } from "@flow/common/captcha_provider";

export interface CaptchaProvider {
  def: CaptchaProviderDef;

  loadCaptcha: () => void;
  captchaExecute: (action: string) => Promise<string | undefined>;
}

let captcha_provider_handler: CaptchaProvider | undefined = undefined;

export function getCaptchaProviderHandler(): Readonly<typeof captcha_provider_handler> {
  return captcha_provider_handler;
}

export function registerCaptchaProvider(handler: CaptchaProvider) {
  captcha_provider_handler = handler;
}
